import React, { useState, useEffect } from 'react';
import axios from '../AxiosInstance';

export const ListContext = React.createContext();

export const ListProvider = ({ children }) => {
  const [brokerList, setBrokerList] = useState([]);
  const [productList, setProductList] = useState([]);
  const portTypeList = [
    { id: 'Master', title: 'Master' },
    { id: 'CopyTrade', title: 'CopyTrade' },
    { id: 'Manual', title: 'Manual' },
  ];

  useEffect(() => {
    axios
      .get('/brokers')
      .then((res) => {
        // console.log(res.data, ' RBOKERs');
        setBrokerList([
          { id: 0, title: 'ไม่ระบุ' },
          ...res.data.map((broker) => {
            return { id: broker.brokerId, title: broker.brokerName };
          }),
        ]);
      })
      .catch((err) => {
        console.error(err.response);
      });
    axios
      .get('/products')
      .then((res) => {
        // console.log(res.data, ' PRODUCtS');
        setProductList([
          { id: 0, title: 'ไม่ระบุ' },
          ...res.data.map((prod) => {
            return { id: prod.productId, title: prod.name };
          }),
        ]);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, []);

  return (
    <ListContext.Provider
      value={{
        brokerList,
        productList,
        portTypeList,
      }}>
      {children}
    </ListContext.Provider>
  );
};
